import { inject, observer } from 'mobx-react'
import useMediaQuery from '@mui/material/useMediaQuery'
import { StepContent } from '../../elements'
import { MOBILE_VIEWPORT } from '../../../../guided-toolbox/utils/breakpoints'
import { getHeadingSegments } from './headingMessage'
import { buildContributionsViewModel } from './contributionsViewModel'
import ContributionsTable from './ContributionsTable'
import { Heading } from './style'

function HeadingSegments({ segments }) {
  return segments.map((segment, index) =>
    segment.bold ? <strong key={index}>{segment.text}</strong> : segment.text
  )
}

function Contributions({ store }) {
  const isMobile = useMediaQuery(MOBILE_VIEWPORT)
  const { baseCase, recommendedCase, person } = store

  // Return nothing here because the parent shell renders the loading state.
  if (!baseCase || !recommendedCase || !person) {
    return null
  }

  const {
    includeSpouse,
    isModified,
    employerPlans,
    iras,
    outOfPlanMonthlySavings,
    currentMonthlyTotal,
    recommendedMonthlyTotal,
    isPercentOnly,
    aggregatePercent,
  } = buildContributionsViewModel(store)

  const { segments } = getHeadingSegments({
    includeSpouse,
    isModified,
    currentMonthly: currentMonthlyTotal,
    recommendedMonthly: recommendedMonthlyTotal,
    isPercentOnly,
    aggregatePercent,
  })

  return (
    <StepContent>
      <Heading>
        <HeadingSegments segments={segments} />
      </Heading>
      <ContributionsTable
        employerPlans={employerPlans}
        iras={iras}
        outOfPlanMonthlySavings={outOfPlanMonthlySavings}
        isModified={isModified}
        isMobile={isMobile}
      />
    </StepContent>
  )
}

export default inject('store')(observer(Contributions))
